// extracted by mini-css-extract-plugin
export default {"border-container":"1px solid rgb(221, 224, 230)","border-radius":"6px","elevation-container":"0px 1px 0px 0px rgba(221, 224, 230, 0.8)","container":"styles_container__RC5Ff"};